import {StackPlayerClassifier as BaseStackPlayerClassifier} from 'services/stack-player-classifier';
import CorrelationStackLineupAnalyzer from './correlation-stack-lineup-analyzer';
import Const from 'constants';

class StackPlayerClassifier extends BaseStackPlayerClassifier {
    constructor(params) {
        super();
        const {players, stacking, simplexLineup} = params;

        this._players = players;
        this._stacking = stacking;
        this._stackLineupAnalyzer = new CorrelationStackLineupAnalyzer(players);
        this._simplexLineup = simplexLineup;
    }

    isPlayerFromPrimaryStack(player) {
        const [primaryGroupName] = this._simplexLineup.getDistilled(Const.LP_CS_PRIMARY_STACK_GROUP_PREFIX);
        const [keyPlayerId] = this._simplexLineup.getDistilled(Const.LP_CS_UNIVERSAL_STACK_GROUP_PREFIX);

        if (primaryGroupName) {
            if (!this._stacking.hasOwnProperty(primaryGroupName)) {
                return false;
            }

            const stackItem = this._stacking[primaryGroupName];
            const keyPlayer = this._players.getPlayer(stackItem.keyPlayerId);

            if (keyPlayer.getId() === player.getId()) {
                return true;
            }

            this._stackLineupAnalyzer.analyze(this._simplexLineup, {
                teamName: keyPlayer.team,
                isGameStack: stackItem.isGameStack,
                onlyPositions: ['WR', 'TE', 'RB'],
            });

            return inArray(player.getId(), this._stackLineupAnalyzer.getStackedPlayerIds());
        } else if (keyPlayerId) {
            const keyPlayer = this._players.getPlayer(keyPlayerId);

            if (keyPlayer.getId() === player.getId()) {
                return true;
            }

            this._stackLineupAnalyzer.analyze(this._simplexLineup, {
                teamName: keyPlayer.team,
                isGameStack: false,
                onlyPositions: ['WR', 'TE'],
            });

            return inArray(player.getId(), this._stackLineupAnalyzer.getStackedPlayerIds());
        }

        return false;
    }

    isPlayerFromSecondaryStack(player) {
        const combinations = this._simplexLineup.getRaw(Const.LP_CS_COMBINATION_PREFIX);

        for (let combo of combinations) {
            const [, teamName, comboType] = combo.split(Const.LP_ITEM_DELIMITER);

            if (!teamName || !comboType) {
                continue;
            }

            const positions = Const.SECONDARY_STACK_COMBINATION_TYPES[comboType];

            if (!positions) {
                continue;
            }

            const {mainTeamPositions, opponentTeamPositions} = positions;

            if (teamName === player.team && inArray(player.positionName, mainTeamPositions)) {
                return true;
            }
            if (teamName === player.opponent && inArray(player.positionName, opponentTeamPositions)) {
                return true;
            }
        }

        return false;
    }
}

export {StackPlayerClassifier};
